import {
  type ApiResponse,
  type PaginatedResponse
} from '../../api-client';

import {
  apiRequest
} from './client';

import type {
  Event
} from './types/events.types';

export interface ListEventsParams {
  entityType?: string
  entityId?: number
  limit?: number
  offset?: number
}

export async function listEvents(
  params: ListEventsParams = {},
  token: string
): Promise<PaginatedResponse<Event>> {

  const query = new URLSearchParams();

  if (params.entityType !== undefined) {

    query.set('entityType', params.entityType);
  }

  if (params.entityId !== undefined) {

    query.set('entityId', String(params.entityId));
  }

  if (params.limit !== undefined) {

    query.set('limit', String(params.limit));
  }

  if (params.offset !== undefined) {

    query.set('offset', String(params.offset));
  }

  const qs = query.size > 0 ? `?${ query.toString() }` : '';
  return apiRequest<PaginatedResponse<Event>>(`/internal/events${ qs }`, undefined, token);
}

export async function getEventById(
  id: number,
  token: string
): Promise<ApiResponse<Event>> {

  return apiRequest<ApiResponse<Event>>(`/internal/events/${ id }`, undefined, token);
}
